import React from "react";
import { connect } from "react-redux";
// import {addFlashMessage} from '../actions/flashMessages';
import PropTypes from "prop-types";
import { withAlert } from "react-alert";
import { bindActionCreators } from "redux";

import { logoutUser, clearSignupData } from "../Actions/actions";

export default function (ComposedComponent) {
  class Authenticate extends React.Component {
    componentDidMount() {
      const { data: { userInfo },
        // location: { pathname }
      } = this.props
      const AuthInfo = localStorage.getItem('user');
      // if (AuthInfo !== null || typeof userInfo.user !== 'undefined') {
      if (AuthInfo !== null) {
        const loginStatus = localStorage.getItem("loginStatus");
        const acceptedDocument = localStorage.getItem("acceptedDocument");

        const roleName = localStorage.getItem("roleName");
        if (roleName === "Consumer" || roleName === "Business-User") {
          if (loginStatus === "error") {
            this.context.router.history.push("/profile-terms");
          } else {
            if (acceptedDocument === "true")
              this.context.router.history.push(
                `/service-agreement/${userInfo.userObject.userDto.pendingServiceAgreementUrl}`
              );
          }
        }
      } else {
        // this.props.alert.error("Sorry You are Not Authorised!");
        this.props.logoutUser();
        this.context.router.history.push("/");
      }
      // if (pathname !== '/signup-step1' && pathname !== '/signup' && pathname !== '/signup-plan-page' && pathname !== '/signup-terms-condition' && pathname !== '/signup-signature-page') {
      //   // localStorage.clear();
      //   localStorage.removeItem('persist:root');
      //   this.props.clearSignupData();
      //   // console.log('dddddddddddddddddddddddddddddddddddddddddddddd');
      // }
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  Authenticate.propsTypes = {
    // isAuthenticated: PropTypes.bool.isRequired,
    // addFlashMessage: PropTypes.func.isRequired
  };
  Authenticate.contextTypes = {
    router: PropTypes.object.isRequired
  };

  function mapStateToProps(state) {
    return {
      data: state.data
      //  isAuthenticated: state.auth.isAuthenticated
    };
  }

  const mapDispatchToProps = dispatch =>
    bindActionCreators(
      {
        logoutUser,
        clearSignupData
      },
      dispatch
    );

  return withAlert(connect(mapStateToProps, mapDispatchToProps)(Authenticate));
}
